module.exports = __webpack_public_path__ + "static/img/ota-img.7d4aad0c.png";